import { HTMLAttributes, PropsWithChildren, useCallback } from 'react'
import './section-list.component.scoped.scss'
import { SqButton } from '@squidit/react-css'

interface Props extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  title: string
  labelButton: string
  onClickButton: () => void
  show?: boolean
  onSetShow?: (show: boolean) => void
}

export default ({ children, title, labelButton, onClickButton, show = true }: Props) => {
  const handleButton = useCallback(() => {
    if (onClickButton && typeof onClickButton === 'function') {
      onClickButton()
    }
  }, [onClickButton])

  return show ? (
    <div className="section-list">
      <header className="header-list display-flex justify-content-space-between align-items-center" style={{ gap: '0.5rem' }}>
        <h3 className="title-section m-0" style={{ width: 'auto' }}>
          {title}
        </h3>
        <SqButton
          borderColor="var(--primary_color)"
          size="sm"
          color="var(--transparent)"
          textColor="var(--primary_color)"
          style={{ borderRadius: '20px', whiteSpace: 'nowrap', height: 'fit-content', flexShrink: 0 }}
          onClick={() => handleButton()}
        >
          {labelButton}
        </SqButton>
      </header>
      {children}
    </div>
  ) : null
}
